import React from "react";

import SubFamily from "components/Tvendo/Article/DataMaster/SubFamily/List.js";

export default function () {
  return <SubFamily />;
}
